import React, {useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Panel} from "primereact/panel";
import {InputText} from "primereact/inputtext";
import {TriStateCheckbox} from "primereact/tristatecheckbox";
import axios from "axios";

const PartnerListComponent = (props) => {

  const {t, detailedSearchVisible, view, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  

  const LIST_STORAGE_KEY = 'lastPartnerListState';
  const DS_STORAGE_KEY = 'lastPartnerDetailedSearchForm';
  const DEFAULT_SORT_FIELD = 'name';
  const DEFAULT_SORT_ORDER = 1;
  const DEFAULT_DETAILED_SEARCH_QUERY = 'search[active][operator]==&search[active][value]=true';
  const savedListState = localStorage.getItem(LIST_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(LIST_STORAGE_KEY))
    : null;
  const savedDetailedForm = localStorage.getItem(DS_STORAGE_KEY)
    ? JSON.parse(localStorage.getItem(DS_STORAGE_KEY))
    : null;

  const isForcedVendorService = props.forcedSearchQuery === 'search[vendor_service][operator]==&search[vendor_service][value]=true';

  const [rows, setRows] = useState(
    savedListState?.rows || Number(process.env.REACT_APP_LIST_ROW_DEFAULT)
  );
  const dt = useRef(null);
  const [detailedSearchQuery, setDetailedSearchQuery] = useState(
    savedListState?.detailedSearchQuery ?? DEFAULT_DETAILED_SEARCH_QUERY
  );

  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  const [dsActive, setDsActive] = useState(savedDetailedForm?.dsActive ?? true);
  // const [dsVendorService, setDsVendorService] = useState(savedDetailedForm?.dsVendorService ?? null);
  const [dsVendorService, setDsVendorService] = useState( isForcedVendorService ? true : (savedDetailedForm?.dsVendorService ?? null));
  const [dsVendorMaterial, setDsVendorMaterial] = useState(savedDetailedForm?.dsVendorMaterial ?? null);
  const [dsCustomer, setDsCustomer] = useState(savedDetailedForm?.dsCustomer ?? null);
  const [dsType, setDsType] = useState(savedDetailedForm?.dsType ?? null);
  const [dsCountry, setDsCountry] = useState(savedDetailedForm?.dsCountry ?? null);
  const [dsPostalCode, setDsPostalCode] = useState(savedDetailedForm?.dsPostalCode ?? '');
  const [dsCity, setDsCity] = useState(savedDetailedForm?.dsCity ?? '');
  const [dsAddress, setDsAddress] = useState(savedDetailedForm?.dsAddress ?? '');
  const [dsVatNumber, setDsVatNumber] = useState(savedDetailedForm?.dsVatNumber ?? '');
  const [dsName, setDsName] = useState(savedDetailedForm?.dsName ?? '');

  const [countries, setCountries] = useState([]);

  const [lazyParams, setLazyParams] = useState(() => {
    const savedLazyParams = savedListState?.lazyParams;
    if (savedLazyParams) {
      return {
        ...savedLazyParams,
        first: savedLazyParams.first ?? 0,
        rows: savedLazyParams.rows ?? rows,
        page: savedLazyParams.page ?? 0,
        sortField: savedLazyParams.sortField || DEFAULT_SORT_FIELD,
        sortOrder: typeof savedLazyParams.sortOrder === 'number' ? savedLazyParams.sortOrder : DEFAULT_SORT_ORDER,
      };
    }
    return {
      first: 0,
      rows: rows,
      page: 0,
      sortField: DEFAULT_SORT_FIELD,
      sortOrder: DEFAULT_SORT_ORDER,
    };
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      let extraQuery = '';
      let finalDetailedQuery = detailedSearchQuery;
      if (props.forcedSearchQuery && !finalDetailedQuery.includes(props.forcedSearchQuery)) {
        finalDetailedQuery = finalDetailedQuery 
          ? finalDetailedQuery + (finalDetailedQuery.endsWith('&') || props.forcedSearchQuery.startsWith('&') ? '' : '&') + props.forcedSearchQuery
          : props.forcedSearchQuery;
      }
      if (finalDetailedQuery) {
        if (!query || query.toString().length === 0) {
          query = '?' + finalDetailedQuery;
        } else if (query.toString().includes('?')) {
          query = query + (query.toString().endsWith('?') || query.toString().endsWith('&') ? '' : '&') + finalDetailedQuery;
        } else {
          query = '?' + query + '&' + finalDetailedQuery;
        }
      }
      if (view === 'customer') {
        extraQuery = 'search[customer][operator]==&search[customer][value]=true';
      } else if (view === 'vendor_service') {
        extraQuery = 'search[vendor_service][operator]==&search[vendor_service][value]=true';
      } else if (view === 'vendor_material') {
        extraQuery = 'search[vendor_material][operator]==&search[vendor_material][value]=true';
      } else {
        extraQuery = '';
      }
      if (extraQuery) {
        query += (query.endsWith('?') || query.endsWith('&') ? '' : '&') + extraQuery;
      }
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner" + query,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setPartners(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const persistDetailedForm = () => {
    const payload = {
      dsActive,
      dsVendorService,
      dsVendorMaterial,
      dsCustomer,
      dsType,
      dsCountry,
      dsPostalCode,
      dsCity,
      dsAddress,
      dsVatNumber,
      dsName,
    };
    localStorage.setItem(DS_STORAGE_KEY, JSON.stringify(payload));
  };

  const clearDetailedFormPersist = () => {
    localStorage.removeItem(DS_STORAGE_KEY);
  };

  const buildDetailedSearchQuery = () => {
    let parts = [];
    if (dsActive !== null) {
      parts.push(`search[active][operator]==&search[active][value]=${dsActive}`);
    }
    if (dsVendorService !== null) {
      parts.push(`search[vendor_service][operator]==&search[vendor_service][value]=${dsVendorService}`);
    }
    if (dsVendorMaterial !== null) {
      parts.push(`search[vendor_material][operator]==&search[vendor_material][value]=${dsVendorMaterial}`);
    }
    if (dsCustomer !== null) {
      parts.push(`search[customer][operator]==&search[customer][value]=${dsCustomer}`);
    }
    if (dsType) {
      parts.push(`search[type][operator]==&search[type][value][]=${encodeURIComponent(dsType)}`);
    }
    if (dsCountry) {
      parts.push(`search[address_country_code][operator]==&search[address_country_code][value][]=${encodeURIComponent(dsCountry)}`);
    }
    if (dsName) {
      parts.push(`search[name][operator]=like&search[name][value]=*${encodeURIComponent(dsName)}*`);
    }
    const like = (field, val) => {
      const v = (val || '').toString().trim();
      if (!v) return;
      parts.push(`search[${field}][operator]=like&search[${field}][value]=*${encodeURIComponent(v)}*`);
    };
    like('address_postal_code', dsPostalCode);
    like('address_city', dsCity);
    like('address_detail', dsAddress);
    like('vat_number', dsVatNumber);
    return parts.filter(Boolean).join('&');
  };

  const doDetailedSearch = () => {
    const q = buildDetailedSearchQuery();
    setDetailedSearchQuery(q);
    setLazyParams((prev) => ({
      ...prev,
      first: 0,
      page: 0,
    }));
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {(JSON.parse(localStorage.getItem('roles') || '[]').includes('role_partner_write')) &&
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                        tooltip={t('view')} tooltipOptions={{position: 'left'}}
                        onClick={() => {
                          localStorage.setItem('breadcrumb', JSON.stringify([
                              {label: t('App\\Partner\\Menu'), url: '/#/partner'},
                              {label: rowData.name, url: '/#/partner/read/' + rowData.id},
                            ])
                          )
                          history.push('/partner/read/' + rowData.id)
                        }}/>
          }
        {localStorage.getItem('roles').toString().includes('role_') && (JSON.parse(localStorage.getItem('roles') || '[]').includes('role_partner_write')) &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    history.push('/partner/update/' + rowData.id)
                  }}/>
        }
      </React.Fragment>
    );
  }

  // const apiCall = (method, url, data) => {
  //   return axios({
  //     method: method,
  //     url: process.env.REACT_APP_API_HOST + url,
  //     data,
  //     params: {},
  //     headers: {
  //       'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
  //       'App-Network': localStorage.getItem("networkId")
  //     }
  //   })
  // }

  useEffect(() => {
    localStorage.setItem(LIST_STORAGE_KEY, JSON.stringify({
      rows,
      lazyParams,
      detailedSearchQuery,
      sortField: lazyParams.sortField || DEFAULT_SORT_FIELD,
      sortOrder: typeof lazyParams.sortOrder === 'number' ? lazyParams.sortOrder : DEFAULT_SORT_ORDER,
    }));
  }, [rows, lazyParams, detailedSearchQuery]);

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      rows: rows
    }));
  }, [rows]);

  useEffect(() => {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/country",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setCountries(Array.isArray(response.data) ? response.data : []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, detailedSearchQuery, view, window.App.state.rerenderPartnerList])

  return (
    <>
      {/* <div className={"p-grid"}>
        <div className={"p-col-12 p-text-right"}>
          <Button
            type="button"
            label={t('detailedSearch')}
            icon="pi pi-filter"
            className="p-button-outlined p-mr-2"
            onClick={() => setDetailedSearchVisible(!detailedSearchVisible)}
          />
        </div>
      </div> */}
      {(detailedSearchVisible  || view === 'search') &&
        <Panel className="p-mb-2" onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              doDetailedSearch();
            }
          }}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnName2')}</label>
                <InputText value={dsName} onChange={(e) => setDsName(e.target.value)} />
              </div>
            </div>
            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnType')}</label>
                <Dropdown
                  value={dsType}
                  options={[
                    { label: 'Személy', value: 'PERSON' },
                    { label: 'Cég', value: 'ORGANISATION' },
                    { label: 'Egyéb', value: 'OTHER' },
                  ]}
                  onChange={(e) => setDsType(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnCountry')}</label>
                <Dropdown
                  value={dsCountry}
                  options={countries.map(country => ({ label: country.name, value: country.code }))}
                  onChange={(e) => setDsCountry(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>

            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnPostalCode')}</label>
                <InputText value={dsPostalCode} onChange={(e) => setDsPostalCode(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnCity')}</label>
                <InputText value={dsCity} onChange={(e) => setDsCity(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid">
                <label>{t('columnAddress')}</label>
                <InputText value={dsAddress} onChange={(e) => setDsAddress(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnTaxNumber')}</label>
                <InputText value={dsVatNumber} onChange={(e) => setDsVatNumber(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-12"}>
              <div className="p-field p-fluid">
                <label>&nbsp;</label>
                <div className="p-fluid p-py-1">
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox value={dsActive} onChange={(e) => setDsActive(e.value)} />
                    &nbsp;{t('columnActive')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox value={dsVendorService} onChange={(e) => setDsVendorService(e.value)} disabled={isForcedVendorService} />
                    &nbsp;{t('columnSupplierService')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox value={dsVendorMaterial} onChange={(e) => setDsVendorMaterial(e.value)} />
                    &nbsp;{t('columnSupplierMaterial')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox value={dsCustomer} onChange={(e) => setDsCustomer(e.value)} />
                    &nbsp;{t('columnCustomer2')}
                  </label>
                </div>
              </div>
            </div>

            <div className={"p-col-12 p-text-right"}>
              <Button
                type="button"
                label={t('dsClearCriteria')}
                icon="pi pi-times"
                className="p-button-danger p-mr-2"
                onClick={() => {
                  setDsActive(null);
                  setDsVendorService(null);
                  setDsVendorMaterial(null);
                  setDsCustomer(null);
                  setDsType(null);
                  setDsCountry(null);
                  setDsPostalCode('');
                  setDsCity('');
                  setDsAddress('');
                  setDsVatNumber('');
                  setDetailedSearchQuery('');
                  setDsName('');
                  clearDetailedFormPersist();
                  localStorage.removeItem(LIST_STORAGE_KEY);
                  setLazyParams({
                    first: 0,
                    rows: rows,
                    page: 0,
                    sortField: 'name',
                    sortOrder: 1,
                  });
                }}
              />
              <Button
                type="button"
                label={t('dsSearch')}
                icon="pi pi-search"
                className="p-button-primary"
                onClick={() => {
                  const q = buildDetailedSearchQuery();
                  setDetailedSearchQuery(q);
                  persistDetailedForm();
                  setLazyParams({
                    ...lazyParams,
                    first: 0,
                    page: 0,
                  });
                }}
              />
            </div>
          </div>
        </Panel>
      }
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={partners} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
                selectionMode="single"
                onRowDoubleClick={(rowData) => {
                  if (window.App.urlVars().search === 'partner') {
                    let _params = '?';
                    Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                      if (key !== 'search' && key !== 'partner') {
                        _params += key + '=' + value + '&';
                      }
                    });
                    _params += 'partnerId=' + rowData.data.id;
                    _params += '&partnerName=' + encodeURIComponent(rowData.data.name);
                    if (window.location.href.includes('/#/project?create=project')) {
                      history.push('/project' + _params);
                    } else {
                      history.push(props.backlink + _params);
                    }
                  }
                }}
      >
        <Column field="active" header={t('columnActive')} sortable body={(rowData) => {
          return (
            <>
              {rowData.active === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column field="type" header={t('columnType')} sortable body={(rowData) => {
          return (
            <>
              {rowData.type === "PERSON" &&
                <>
                  Személy
                </>
              }
              {rowData.type === "ORGANISATION" &&
                <>
                  Cég
                </>
              }
              {rowData.type === "OTHER" &&
                <>
                  Egyéb
                </>
              }
            </>
          )
        }}></Column>
        <Column field="name" header={t('columnName2')} bodyClassName="col-body-font-bold" sortable></Column>
        <Column field="address_country_code" header={t('columnCountry')} sortable></Column>
        <Column field="address_postal_code" header={t('columnPostalCode')} sortable></Column>
        <Column field="address_city" header={t('columnCity')} sortable></Column>
        <Column field="address_detail" header={t('columnAddress')} sortable></Column>
        <Column field="vat_number" header={t('columnTaxNumber')} sortable></Column>
        <Column field="vendor_service" header={t('columnSupplierService')} sortable body={(rowData) => {
          return (
            <>
              {rowData.vendor_service === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column field="vendor_material" header={t('columnSupplierMaterial')} sortable body={(rowData) => {
          return (
            <>
              {rowData.vendor_material === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column field="costomer" header={t('columnCustomer2')} sortable body={(rowData) => {
          return (
            <>
              {rowData.customer === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column field="created_at" header={t('columnCreatedAt')} className={"p-text-nowrap"} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} className={"p-text-nowrap"} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PartnerListComponent);
